import Layout from "../components/layout";

const IndexPage = () => <Layout>Foo</Layout>;

export default IndexPage;
